import Credit from './Credit';

export default Credit;
